import { render, staticRenderFns } from "./DfpAd.vue?vue&type=template&id=e1439316&"
import script from "./DfpAd.vue?vue&type=script&lang=js&"
export * from "./DfpAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports